var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccountAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    transform: "translate(0.07831815501466063 -0.09536708187563697) rotate(322.9 16 16)",
    fill: "#FB182B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    transform: "translate(6.495883617230259 -12.975464474027534) rotate(344.6 16 16)",
    fill: "#033B5E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    transform: "translate(-26.55206659599648 3.4155666128483317) rotate(234.7 16 16)",
    fill: "#EDF500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountAvatar);
export default __webpack_public_path__ + "static/media/icon-account-avatar.cad5ab3a2dad2371cd2c10ed0ad0d5b0.svg";
export { ForwardRef as ReactComponent };